/**
 * Do not edit this file it is auto-generated by io-utils / gen-api-models.
 * See https://github.com/pagopa/io-utils
 */
/* eslint-disable  */

import { IbanLabel } from "./IbanLabel";
import * as t from "io-ts";
import { UTCISODateFromString } from "@pagopa/ts-commons/lib/dates";
import { PatternString } from "@pagopa/ts-commons/lib/strings";

// required attributes
const IbanEnhancedR = t.interface({
  ci_owner: t.string,

  due_date: UTCISODateFromString,

  iban: PatternString("[a-zA-Z]{2}\\d{2}[a-zA-Z0-9]{1,30}"),

  is_active: t.boolean,

  publication_date: UTCISODateFromString,

  validity_date: UTCISODateFromString
});

// optional attributes
const IbanEnhancedO = t.partial({
  company_name: t.string,

  description: t.string,

  labels: t.readonlyArray(IbanLabel, "array of IbanLabel")
});

export const IbanEnhanced = t.intersection(
  [IbanEnhancedR, IbanEnhancedO],
  "IbanEnhanced"
);

export type IbanEnhanced = t.TypeOf<typeof IbanEnhanced>;
